import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Text from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('MessageDrawerListFooter')
export default class MessageDrawerListFooter extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    btnClassName: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    positionBottom: PropTypes.number,
  };

  static defaultProps = {
    positionBottom: 75,
  };

  render() {
    const { title, btnClassName, handleClick, positionBottom } = this.props;

    return (
      <Box z={2} absolute bottom={positionBottom} tcenter left={75}>
        <Box
          muiShadow
          inlineBlock
          cursor="pointer"
          w={170}
          bg="blue"
          bradius={50}
          ph={20}
          pv={7}
          onClick={handleClick}
          className={btnClassName}
        >
          <Text fw600 white i18n={title} />
        </Box>
      </Box>
    );
  }
}
